import React from 'react';
import { Box, IconButton, makeStyles } from '@material-ui/core';
import IconRenderer from 'global/react-mui/atoms/IconRenderer';
import { uiSliceActions } from '../../../store/modules/ui/reducer';
import { useDispatch } from 'react-redux';

const MobileFilterToggler = (): JSX.Element => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const showFilterDrawer = () => dispatch(uiSliceActions.setIsFilterDrawerOpen({ isOpen: true }));

	return (
		<Box display="flex" justifyContent="center" alignItems="center" height="100%">
			<IconButton className={classes.button} onClick={showFilterDrawer}>
				<IconRenderer icon="filter" />
			</IconButton>
		</Box>
	);
};

export default MobileFilterToggler;

const useStyles = makeStyles((theme) => ({
	button: {
		border: `1px solid #62677E`,
	},
}));
